import ianAvatar from './images/authors/ian.jpg'
import niallAvatar from './images/authors/niall.jpg'
import jayAvatar from './images/authors/JaySobel.jpeg'
import andreyAvatar from './images/authors/AndreyBystrov.jpeg'
import tomasAvatar from './images/authors/TomasSobotik.jpeg'
import mrG from './images/authors/IanGray.jpeg'
import fernandoBritoAvatar from './images/authors/FernandoBrito.jpeg'
import garyAvatar from './images/authors/GaryJames.jpeg'
import jovanAvatar from './images/authors/JovanSakovic.jpeg'
import adamAvatar from './images/authors/AdamWisniewski.jpeg'
import miguelAvatar from './images/authors/MiguelDuarte.jpeg'
import jeffAvatar from './images/authors/JeffSkoldberg.jpeg'
import gregAvatar from './images/authors/GregFinley.jpeg'
import alanAvatar from './images/authors/AlanCruickshank.jpeg'
import morganAvatar from './images/authors/MorganSadr-Hashemi.jpg'
import mikeAvatar from './images/authors/MikeBertrand-Pickfield.jpeg'
import alexAvatar from './images/authors/alexcaruso.jpeg'
import { StaticImageData } from 'next/image'
import { ReactNode } from 'react'

export interface Author {
  name: string
  title: string
  avatar: StaticImageData
  bio?: string | ReactNode
}

export const jeff = {
  name: 'Jeff Skoldberg',
  title: 'Principal Consultant at Green Mountain Data Solutions',
  bio: 'Jeff Skoldberg is a Data and Analytics Consultant with 15+ years experience in automating insights and using data to control business processes.  From a technology standpoint, he specializes in Snowflake + dbt + Tableau.  From a business topic standpoint, he has experience in Public Utility, Clinical Trials, Publishing, CPG, and Manufacturing.  Jeff adds unique value for his supply chain clients, as he is well versed in all topics related to planning, forecasting, inventory and supply chain KPIs.  Reach out any time! jeff@gmdata.co',
  avatar: jeffAvatar,
}

export const ian = {
  name: 'Ian Whitestone',
  title: 'Co-founder & CEO of SELECT',
  bio: 'Ian is the Co-founder & CEO of SELECT, a SaaS Snowflake cost management and optimization platform. Prior to starting SELECT, Ian spent 6 years leading full stack data science & engineering teams at Shopify and Capital One. At Shopify, Ian led the efforts to optimize their data warehouse and increase cost observability.',
  avatar: ianAvatar,
}

export const jovan = {
  name: 'Jovan Saković',
  title: 'Sr. Data Engineer at Tasman Analytics',
  bio: 'Jovan is currently deploying his resources at Tasman Analytics, enabling their clients to get to business value as quickly as possible by deploying scalable and proven data platforms. With over 20 clients under his Tasman belt, he has worked on a wide range of MDS tools, but is still most excited about Terraform-ing Snowflake accounts. Jovan enjoys establishing partnerships with products he believes in, like Metaplane, Prefect and, of course, SELECT',
  avatar: jovanAvatar,
}

export const miguel = {
  name: 'Miguel Duarte',
  title: 'Data Engineer at Tasman Analytics',
  bio: 'Miguel is a Data Engineer at Tasman Analytics, where he helps fast-growing companies enhance their data capabilities. With a background in BI and Data Analysis, he has gained valuable experience working in consultancy and product companies. More recently, driven by curiosity and a desire to gain more exposure to the technical aspects of the data lifecycle, he transitioned to Data Engineering. Miguel works daily with tools like Snowflake to help organizations build and optimize their data infrastructure.',
  avatar: miguelAvatar,
}

export const graydiant = {
  name: 'Ian Gray',
  title: 'Software Engineer at SELECT',
  bio: 'Ian is software engineer based out of Toronto, Canada.',
  avatar: mrG,
}

export const niall = {
  name: 'Niall Woodward',
  title: 'Co-founder & CTO of SELECT',
  bio: "Niall is the Co-Founder & CTO of SELECT, a SaaS Snowflake cost management and optimization platform. Prior to starting SELECT, Niall was a data engineer at Brooklyn Data Company and several startups. As an open-source enthusiast, he's also a maintainer of SQLFluff, and creator of three dbt packages: dbt_artifacts, dbt_snowflake_monitoring and dbt_snowflake_query_tags.",
  avatar: niallAvatar,
}

export const fernandobrito = {
  name: 'Fernando Brito',
  title: 'Software Engineer at SELECT',
  bio: 'Fernando is a software engineer based out of Sweden.',
  avatar: fernandoBritoAvatar,
}

export const andrey = {
  name: 'Andrey Bystrov',
  title: 'Analytics Engineer at Deliveroo',
  bio: 'Andrey is an experienced data practitioner, currently working as an Analytics Engineer at Deliveroo. Andrey has a strong passion for data modelling and SQL optimization. He has a deep understanding of the Snowflake platform, and uses that knowledge to help his team build performant and cost effective data pipelines. Andrey is passionate about the topic, and regular shares his learnings back with the community.',
  avatar: andreyAvatar,
}

export const jay = {
  name: 'Jay Sobel',
  title: 'Analytics Engineer at Ramp',
  bio: 'Jay is a Senior Analytics Engineer at Ramp, one of the fastest growing startups in the US. Jay has nearly a decade of data analysis & engineering experience, spanning many fast growing technology companies like Gopuff, Drizly, Wanderu and LevelUp. Jay is a passionate member of the dbt and Snowflake community, regular contributing to optimization and general best practice discussions.',
  avatar: jayAvatar,
}

export const tomas = {
  name: 'Tomáš Sobotík',
  title: 'Senior Data Engineer & Snowflake SME at Norlys',
  bio: "Tomas is a longstanding Snowflake Data SuperHero and general Snowflake subject matter expert. His extensive experience in the data world spans over a decade, during which he has served as a Snowflake data engineer, architect, and admin on various projects across diverse industries and technologies. Tomas is a core community member, actively sharing his expertise and inspiring others. He's also an O'Reilly instructor, leading live online training sessions.",
  avatar: tomasAvatar,
}

export const gary = {
  name: 'Gary James',
  title: 'Senior Analytics Engineer at Beauty Pie',
  bio: "Gary is a Senior Analytics Engineer at Beauty Pie, a makeup and skincare company. With over a decade of experience across any 'data' title you can think of, he's a big fan of all things data/ engineering related. Gary is a very active contributor to a variety of different open source project across the data stack. He created the dbt cloud Terraform provider, and contributes to other projects in the ecosystem like dbt, elementary data, lightdash & Meltano.",
  avatar: garyAvatar,
}

export const adam = {
  name: 'Adam Wisniewski',
  title: 'Software Engineer at SELECT',
  bio: 'Adam is software engineer based out of Toronto, Canada.',
  avatar: adamAvatar,
}

export const greg = {
  name: 'Greg Finley',
  title: 'Software Engineer at SELECT',
  bio: 'Greg is a software engineer at SELECT based out of San Francisco, United States.',
  avatar: gregAvatar,
}

export const alan = {
  name: 'Alan Cruickshank',
  title: 'Software Engineer at SELECT',
  bio: 'Alan is a software engineer at SELECT based out of London, United Kingdom.',
  avatar: alanAvatar,
}

export const morgan = {
  name: 'Morgan Sadr-Hashemi',
  title: 'VP of Engineering at SELECT',
  bio: 'Morgan is VP of engineering at SELECT based out of Kent, United Kingdom.',
  avatar: morganAvatar,
}

export const mike = {
  name: 'Mike Bertrand-Pickfield',
  title: 'Software Engineer at SELECT',
  bio: 'Mike is a software engineer at SELECT based out of Toronto, Canada.',
  avatar: mikeAvatar,
}

export const alex = {
  name: 'Alex Caruso',
  title: 'Lead Data Platform Engineer at Entera',
  bio: 'Alex is a Lead Data Platform Engineer at Entera, based out of New York, United States.',
  avatar: alexAvatar,
}
export const authors = {
  ian: ian,
  niall: niall,
  jay: jay,
  andrey: andrey,
  tomas: tomas,
  graydiant: graydiant,
  gary: gary,
  jovan: jovan,
  fernandobrito: fernandobrito,
  adam: adam,
  miguel: miguel,
  jeff: jeff,
  greg: greg,
  alan: alan,
  morgan: morgan,
  mike: mike,
  alex: alex,
}
